export enum EventType {
  impression = 1,
  viewableMRC50 = 2
}
